/**
 * Calculate weekly word count from user activity
 * @param {Array} activity - Array of activity objects with { date, wordCount }
 * @returns {number} - Total word count for the current week
 */
const calculateWeeklyWordCount = (activity = []) => {
  if (!activity || !Array.isArray(activity)) {
    return 0;
  }

  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);

  // Get start of week (Sunday)
  const startOfWeek = new Date(today);
  const dayOfWeek = today.getDay();
  startOfWeek.setDate(today.getDate() - dayOfWeek);
  startOfWeek.setUTCHours(0, 0, 0, 0);

  // Get end of week (Saturday)
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6);
  endOfWeek.setUTCHours(23, 59, 59, 999);

  // Calculate total words written this week
  let weeklyTotal = 0;
  activity.forEach((entry) => {
    const entryDate = new Date(entry.date);
    entryDate.setUTCHours(0, 0, 0, 0);
    if (entryDate >= startOfWeek && entryDate <= endOfWeek) {
      weeklyTotal += entry.wordCount || 0;
    }
  });

  return weeklyTotal;
};

export default calculateWeeklyWordCount;
